module.exports = __webpack_public_path__ + "static/media/350x140.fe8fde81.png";